module.exports = __webpack_public_path__ + "img/Texture.e53b35d0.svg";